<div class="mt-4">
  <!-- Add Article Button -->
  <div class="d-flex align-items-center justify-content-between">
    <button class="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#articleModal" (click)="resetForm()">
      <i class="fas fa-plus"></i> Add Article
    </button>
    <select class="form-select w-auto mb-3" [(ngModel)]="selectedCategory" (change)="filterByCategory()">
      <option value="">All Categories</option>
      <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
    </select>
  </div>

  <!-- Articles Table -->
  <div class="table-responsive always-scroll">
    <table class="table table-striped align-middle dashboard-table">
      <thead>
        <tr>
          <th>Cover Image</th>
          <th>Title</th>
          <th>Category</th>
          <th>Status</th>
          <th>Author</th>
          <th>Views</th>
          <th>Published At</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let article of articles" class="article-row">
          <td class="image-col">
            <img *ngIf="article.coverUrl" [src]="article.coverUrl" loading="lazy" alt="Preview" class="img-thumbnail" style="width: 60px; height: 60px;">
          </td>
          <td class="title-col">
            <span class="text-lg-wrap text-lg-break">{{ article.title }}</span>
          </td>

          <td class="category-col">
            {{ article.category || 'N/A' }}
          </td>
          <td class="status-col">
            {{ article.status }}
          </td>
          <td class="author-col">
            {{ article.authorName || 'N/A' }}
          </td>
          <td class="views-col">
            {{ article.views || 0 }}
          </td>
         
          <td class="published-col">
            {{ article.publishedAt ? (article.publishedAt.toDate() | date:'short') : 'N/A' }}
          </td>
          <td class="actions-col">
            <button class="btn btn-warning btn-sm me-2" (click)="editArticle(article)">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-danger btn-sm me-2" (click)="deleteArticle(article.id!)">
              <i class="fas fa-trash"></i>
            </button>
            <button class="btn btn-info btn-sm" [routerLink]="['/Article', article.id]">
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="articles.length === 0 && showSpinner==false" style="text-align: center;">
          <td colspan="10" class="text-muted">No articles available</td>
        </tr>
        <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="10">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Article Modal -->
<div class="modal fade" id="articleModal" tabindex="-1" aria-labelledby="articleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <form #articleForm="ngForm" (ngSubmit)="saveArticle(articleForm)">
        <div class="modal-header">
          <h5 class="modal-title" id="articleModalLabel">{{ editMode ? 'Edit Article' : 'Add Article' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- Title -->
          <div class="mb-3">
            <label>Title <span class="text-danger">*</span></label>
            <input type="text" 
                   class="form-control"
                   name="title" 
                   [(ngModel)]="currentArticle.title" 
                   #title="ngModel" 
                   required
                   minlength="3">
            <div *ngIf="title.invalid && title.touched" class="text-danger small">
              <div *ngIf="title.errors?.['required']">Title is required</div>
              <div *ngIf="title.errors?.['minlength']">Title must be at least 3 characters</div>
            </div>
          </div>

          <!-- Category -->
          <div class="mb-3">
            <label>Category <span class="text-danger">*</span></label>
            <select class="form-select"
                    name="category"
                    [(ngModel)]="currentArticle.category"
                    #category="ngModel"
                    required>
              <option value="">Select a category</option>
              <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
              <option value="Other">Other</option>
            </select>
            <div *ngIf="category.invalid && category.touched" class="text-danger small">
              Category is required
            </div>
          </div>

          <!-- Show input only when 'Other' is selected -->
          <div class="mb-3" *ngIf="currentArticle.category === 'Other'">
            <label>Specify Category <span class="text-danger">*</span></label>
            <input type="text"
                   class="form-control"
                   [(ngModel)]="customCategory"
                   #customCategoryModel="ngModel"
                   name="customCategory"
                   required>
            <div *ngIf="customCategoryModel.invalid && customCategoryModel.touched" class="text-danger small">
              Custom category is required when 'Other' is selected
            </div>
          </div>

<!-- Content -->
          <div class="mb-3">
            <label>Content <span class="text-danger">*</span></label>
            <ng-container *ngIf="Editor">
              <ckeditor
                name="content"
                [(ngModel)]="currentArticle.content"
                #content="ngModel"
                [editor]="Editor"
                [config]="editorConfig"
                required
              ></ckeditor>
            </ng-container>
            <ng-container *ngIf="!Editor">
              <textarea
                class="form-control"
                name="content"
                [(ngModel)]="currentArticle.content"
                #content="ngModel"
                required
                rows="5"
              ></textarea>
               <div *ngIf="content.invalid && content.touched" class="text-danger small">
              <div *ngIf="content.errors?.['required']">Content is required</div>
            </div>
            </ng-container>
           
          </div>
          <!-- Status -->
          <div class="mb-3">
            <label>Status <span class="text-danger">*</span></label>
            <select class="form-select"
                    name="status"
                    [(ngModel)]="currentArticle.status"
                    #status="ngModel"
                    required>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
            <div *ngIf="status.invalid && status.touched" class="text-danger small">
              Status is required
            </div>
          </div>

          <!-- Author Name -->
          <div class="mb-3">
            <label>Author Name</label>
            <input type="text" 
                   class="form-control"
                   name="authorName" 
                   [(ngModel)]="currentArticle.authorName">
          </div>

          <!-- Cover Image Upload -->
          <div class="mb-3">
            <label>Cover Image</label>
            <input type="file" class="form-control" (change)="onFileSelected($event)">
            <div *ngIf="currentArticle.coverUrl" class="mt-2">
              <img [src]="currentArticle.coverUrl" loading="lazy" alt="Preview" class="img-thumbnail" style="width: 100px; height: 100px;">
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-success" [disabled]="articleForm.invalid" data-bs-dismiss="modal">
            <i class="fas fa-save"></i> {{ editMode ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div> 
</div>